module.exports = __webpack_public_path__ + "static/img/tool.0840786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tool.png
// module id = uKYp
// module chunks = 1